/* NEOGEN — Header Custom Behavior */
(function () {
  'use strict';

  /* ── PC: Hover to open mega menu ── */
  function initHoverMenu() {
    if (window.innerWidth < 990) return;

    var headerMenu = document.querySelector('.header__inline-menu');
    if (!headerMenu) return;

    headerMenu.querySelectorAll('li').forEach(function (li) {
      var details = li.querySelector('details');
      if (!details) return;

      var closeTimer = null;

      function openMenu() {
        clearTimeout(closeTimer);
        details.setAttribute('open', '');
      }

      function scheduleClose() {
        closeTimer = setTimeout(function () {
          details.removeAttribute('open');
        }, 150);
      }

      li.addEventListener('mouseenter', openMenu);
      li.addEventListener('mouseleave', scheduleClose);

      // Mega menu uses .mega-menu__content, standard dropdown uses .header__submenu
      var submenu = details.querySelector('.mega-menu__content, .header__submenu');
      if (submenu) {
        submenu.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
        });
        submenu.addEventListener('mouseleave', scheduleClose);
      }
    });
  }

  /* ── Mobile: Convert drill-down to accordion ── */
  function initMobileAccordion() {
    if (window.innerWidth >= 990) return;

    var drawer = document.querySelector('header-drawer');
    if (!drawer) return;

    // Clone each submenu summary to strip Dawn's onSummaryClick handler.
    // Removing Dawn's handler prevents .menu-opening and .submenu-open classes
    // from being added — those classes drive the full-panel slide and hide the
    // parent list. Native <details> toggle continues to manage [open].
    // CSS in neogen-header-overrides.css handles show/hide of the submenu inline.
    drawer.querySelectorAll('summary.menu-drawer__menu-item').forEach(function (summary) {
      var clone = summary.cloneNode(true);
      summary.parentNode.replaceChild(clone, summary);
    });
  }

  function init() {
    initHoverMenu();
    initMobileAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
